import usePagination from '../../../Pagination/hooks/usePagination';
import { ROLES_N_PERMISSIONS_PER_PAGE } from '../../../../utils/constants';
import {
  AllRoleResponse,
  GET_ROLES_N_PERMISSIONS,
  RoleResponse,
} from '../../../../apollo/queries/v3/RolesNPermissions/getAllRolesNPermissions.queries';
import { PAGINATION_STATUS } from '../../../Pagination/utils/PageStatus';
import { Role } from '../../types';
import { sortByGroupName } from '../../utils/sortByGroupName';
import appLocalStorage from '../../../../utils/AppLocalStorage';

const useSystemRoles = () => {
  const {
    queryData: { loading, error, data },
    pageData: { currentPage, totalPages, pageStats },
    actions: { setCurrentPage },
  } = usePagination<AllRoleResponse>({
    query: GET_ROLES_N_PERMISSIONS,
    responseField: 'allRoles',
    pageSize: ROLES_N_PERMISSIONS_PER_PAGE,
    pageStatusFormat: `${PAGINATION_STATUS.FROM}-${PAGINATION_STATUS.TO} of ${PAGINATION_STATUS.TOTAL} items`,
  });

  const getRoles = (): Role[] => {
    const responseRoles = data && data.allRoles && data.allRoles.roles;

    if (responseRoles) {
      return responseRoles.map((role: RoleResponse) => ({
        id: role.id,
        name: role.name,
        permissions: `${role.permissions.length} Permissions`,
        modules: [role.category],
        descriptionText: role.description,
        permissionsText: `${sortByGroupName(role.permissions).join(', ')}.`,
      }));
    }

    return [];
  };

  return {
    rolesResponse: {
      isLoading: loading,
      error,
      currentPage,
      totalCount: data && data.allRoles ? data.allRoles.totalCount : 0,
      roles: getRoles(),
      totalPages,
    },
    setCurrentPage,
    isViewOnlyRole: appLocalStorage.isViewOnlyRole(),
    pageStats,
  };
};

export default useSystemRoles;
